import React from 'react';

import Header from '../../main/headers/header';
import AdminCustomerSearchBox from '../../main/search/AdminCustomerSearchBox';

const Customers = () => (
  <div>
    <Header heading="Clients">
      <div className="c-header-primary__components c-header-primary__customers">
        <AdminCustomerSearchBox type="client" />
      </div>
    </Header>
  </div>
);
Customers.propTypes = {
};
Customers.defaultProps = {
};

export default Customers;
